export default __webpack_public_path__ + "images/0x2e9a6df78e42a30712c10a9dc4b1c8656f8f2879.png";